import React from 'react';

/**
 * S179d — deep UI i18n: translate string children & common text props
 * at createElement time when lang !== es. Exact catalog match only.
 */
let translatePhrase = (s) => s;

export function setPhraseTranslator(fn) {
  translatePhrase = typeof fn === 'function' ? fn : (s) => s;
}

const TEXT_PROPS = [
  'placeholder', 'title', 'alt', 'aria-label', 'aria-labelledby',
  'label', 'helperText', 'description', 'emptyText', 'hint',
];

if (!React.__cavI18nPatched) {
  const orig = React.createElement;
  React.createElement = function cavI18nCreateElement(type, config, ...children) {
    let props = config;
    if (props && typeof props === 'object' && !Array.isArray(props)) {
      let changed = false;
      const next = props;
      // shallow copy only if we mutate
      const ensure = () => {
        if (!changed) {
          props = { ...props };
          changed = true;
        }
        return props;
      };
      for (let i = 0; i < TEXT_PROPS.length; i++) {
        const k = TEXT_PROPS[i];
        if (typeof next[k] === 'string' && next[k]) {
          const tr = translatePhrase(next[k]);
          if (tr !== next[k]) {
            ensure()[k] = tr;
          }
        }
      }
      if (typeof next.children === 'string' && next.children) {
        const tr = translatePhrase(next.children);
        if (tr !== next.children) {
          ensure().children = tr;
        }
      }
    }
    if (children.length) {
      let cChanged = false;
      const mapped = children.map((c) => {
        if (typeof c === 'string' && c) {
          const tr = translatePhrase(c);
          if (tr !== c) cChanged = true;
          return tr;
        }
        return c;
      });
      if (cChanged) {
        return orig.apply(this, [type, props, ...mapped]);
      }
    }
    return orig.apply(this, [type, props, ...children]);
  };
  React.__cavI18nPatched = true;
}
